/**
 * Firebase Client Configuration
 * Uses environment variables for security with verified production fallbacks.
 */
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyDBy8mzxH1u05yva31-6O11pkootKOiD80",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "news-afrika.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "news-afrika",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "news-afrika.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "500225036988",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:500225036988:web:bfe9e0aba0fe4c8c88b6b9",
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || "G-35MRFYDVRY"
};
